import './MobileClubOneLoggedIn.scss'

import { ButtonEmpty } from '@tallink/components-lib'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getUser } from '../../../selectors/selectors'

export default function MobileClubOneLoggedIn({ className = '' }) {
  const { t } = useTranslation()
  const user = useSelector(getUser)

  return (
    <div className={`mobile-club-one-logged-in ${className}`}>
      <div className="sso-name">
        {user.firstName} {user.lastName}
      </div>
      <ButtonEmpty className="sign-out-button" onClick={() => window.SSO.signOut()}>
        {t('signOut.link')}
      </ButtonEmpty>
    </div>
  )
}

MobileClubOneLoggedIn.propTypes = {
  className: PropTypes.string
}
